import React from 'react'
import "../styles/About.css"

const About = () => {
    return (
        <>
            <section className="about-wrapper">
                <div className="home-text">
                    <h1 className="fs" data-aos="fade-down">TRAIN HARD. STAY
                        STRONG...</h1>
                    <p className="fs1" data-aos="fade-down">Push your limits, break barriers, and transform yourself every single day. Our expert trainers and state-of-the-art equipment are here to guide your journey.</p>
                    <button className="homebtn">Join Now</button>
                </div>
            </section>
            <section className='abtparent'>
                <div className='abtmain'>
                    <div className='subabt'>
                        <div className='subabt1' data-aos="fade-up">
                            <h2 data-aos="fade-down">Our Story</h2>
                            <p data-aos="fade-up">Welcome to FitBelive, your ultimate fitness destination where strength, motivation, and transformation come together. At FitBelive, we believe that fitness is not just about lifting weights or counting calories — it’s about believing in your potential and unlocking the best version of yourself.</p>
                            <p data-aos="fade-up">Our mission is to inspire individuals to live a healthier, stronger, and more confident life. With world-class equipment, professional trainers, and a supportive environment, we make sure every workout is a step closer to your goals. Whether you want to lose weight, build muscle, boost stamina, or simply feel good about yourself — FitBelive has a program designed just for you. </p>
                            <p data-aos="fade-up">We take pride in creating a space where everyone feels welcome, motivated, and empowered. Our expert team is here to guide you through personalized fitness plans, nutritional advice, and progress tracking to ensure you get real, lasting results.</p>
                            <p data-aos="fade-up">At FitBelive, we don’t just build bodies — we build belief. Because when you believe in your fitness journey, your transformation becomes unstoppable.</p>
                            <p data-aos="fade-up">Believe. Train. Transform. That’s the FitBelive way. 💪🔥</p>
                        </div>
                        <div className='supp'>
                            <div className='subabt3'>
                                <img className='subabt2' src="/assets/about/abt1.png" alt="" data-aos="zoom-in" />
                                <img className='subabt2' src="/assets/about/abt2.png" alt="" data-aos="zoom-in" />
                            </div>
                            <div className='subabt3'>
                                <img className='subabt2' src="/assets/about/abt3.png" alt="" data-aos="zoom-in" />
                                <img className='subabt2' src="/assets/about/abt4.png" alt="" data-aos="zoom-in" />
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default About